import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';

import AddPaymentMethod from 'component/view/Settings/AddPaymentMethod';

import { requireOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/billing/add-payment-method')({
  beforeLoad: requireOperation({
    options: () => RocketAPI.billing.getCreateBillingPaymentMethodMutationOptions(),
    redirectTo: '/n/settings/account-and-security',
  }),
  component: AddPaymentMethod,
});
